import { render, staticRenderFns } from "./_details.vue?vue&type=template&id=0d7feec4"
import script from "./_details.vue?vue&type=script&lang=js"
export * from "./_details.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/burstData/details.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/burstData/details.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports